import { render } from "./EanCheck.vue?vue&type=template&id=89320c5e"
import script from "./EanCheck.vue?vue&type=script&lang=js"
export * from "./EanCheck.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__